var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-6 py-4",domProps:{"innerHTML":_vm._s(_vm.privacyPolicy)}})
}
var staticRenderFns = []

export { render, staticRenderFns }